export default "__VITE_ASSET__T9kgTwr1__"